<template>
  <q-page class="bg-white q-pa-md">
    <router-view />
  </q-page>
</template>
